require('../modules/es.parse-int');
var path = require('../internals/path');

module.exports = path.parseInt;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es/parse-int.js
// module id = 521
// module chunks = 49